// extracted by mini-css-extract-plugin
module.exports = {"ModalContainer":"style_ModalContainer__31H-C","SpinnerIcon":"style_SpinnerIcon__1vKjX","Content":"style_Content__3xSGs"};